import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Role } from '@aragon/connect-core';

function _parseRole(_x, _x2, _x3) {
  return _parseRole2.apply(this, arguments);
}

function _parseRole2() {
  _parseRole2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(role, app, organization) {
    var _a, _b, _c, grantees, roleData;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            grantees = (_a = role === null || role === void 0 ? void 0 : role.grantees) === null || _a === void 0 ? void 0 : _a.map(function (permission) {
              var _a;

              return {
                appAddress: permission === null || permission === void 0 ? void 0 : permission.appAddress,
                allowed: permission === null || permission === void 0 ? void 0 : permission.allowed,
                granteeAddress: permission === null || permission === void 0 ? void 0 : permission.granteeAddress,
                params: ((_a = permission === null || permission === void 0 ? void 0 : permission.params) === null || _a === void 0 ? void 0 : _a.map(function (param) {
                  return {
                    argumentId: param === null || param === void 0 ? void 0 : param.argumentId,
                    operationType: param === null || param === void 0 ? void 0 : param.operationType,
                    argumentValue: param === null || param === void 0 ? void 0 : param.argumentValue
                  };
                })) || [],
                roleHash: permission === null || permission === void 0 ? void 0 : permission.roleHash
              };
            });
            roleData = {
              appAddress: role === null || role === void 0 ? void 0 : role.appAddress,
              appId: app === null || app === void 0 ? void 0 : app.appId,
              artifact: (_b = app === null || app === void 0 ? void 0 : app.version) === null || _b === void 0 ? void 0 : _b.artifact,
              contentUri: (_c = app === null || app === void 0 ? void 0 : app.version) === null || _c === void 0 ? void 0 : _c.contentUri,
              grantees: grantees || [],
              hash: role === null || role === void 0 ? void 0 : role.roleHash,
              manager: role === null || role === void 0 ? void 0 : role.manager
            };
            return _context.abrupt("return", Role.create(roleData, organization));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _parseRole2.apply(this, arguments);
}

export function parseRole(_x4, _x5) {
  return _parseRole3.apply(this, arguments);
}

function _parseRole3() {
  _parseRole3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(result, organization) {
    var _a, _b, app, role;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            app = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.app;
            role = (_b = result === null || result === void 0 ? void 0 : result.data) === null || _b === void 0 ? void 0 : _b.role;

            if (!(!app || !role)) {
              _context2.next = 4;
              break;
            }

            throw new Error('Unable to parse role.');

          case 4:
            return _context2.abrupt("return", _parseRole(role, app, organization));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _parseRole3.apply(this, arguments);
}

export function parseRoles(_x6, _x7) {
  return _parseRoles.apply(this, arguments);
}

function _parseRoles() {
  _parseRoles = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(result, organization) {
    var _a, app, roles;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            app = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.app;
            roles = app === null || app === void 0 ? void 0 : app.roles;

            if (!(!app || !Array.isArray(roles))) {
              _context4.next = 4;
              break;
            }

            throw new Error('Unable to parse roles.');

          case 4:
            return _context4.abrupt("return", Promise.all(roles.map(
            /*#__PURE__*/
            function () {
              var _ref = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee3(role) {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        return _context3.abrupt("return", _parseRole(role, app, organization));

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x8) {
                return _ref.apply(this, arguments);
              };
            }())));

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _parseRoles.apply(this, arguments);
}